import * as z from "zod";

export const contactFormSchema = z.object({
  name: z.string().trim().min(1, "Name is required").max(100, "Name must be less than 100 characters"),
  phone: z.string().trim().min(1, "Phone number is required").regex(/^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/, "Invalid phone number format (e.g., (830) 360-2600)"),
  email: z.string().trim().email("Invalid email address").max(255, "Email must be less than 255 characters").optional().or(z.literal("")),
  zip: z.string().trim().regex(/^\d{5}$/, "ZIP code must be 5 digits"),
  serviceType: z.string().min(1, "Please select a service type"),
  message: z.string().trim().min(1, "Please describe your situation").max(1000, "Message must be less than 1000 characters"),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
